import type { IPlacesPort } from '@onboarding/application/ports';
import type { PlaceAddressDetailsDto } from '@onboarding/application/dtos';

/**
 * Use case for getting parsed address details from a selected place.
 *
 * Flow: placeId → fetch details via port → return DTO.
 *
 * @param props.placesPort - IPlacesPort implementation (injected)
 * @returns Use case executor
 */
export const getPlaceDetailsUseCase = (props: { placesPort: IPlacesPort }) => {
  const { placesPort } = props;

  const execute = async (placeId: string): Promise<PlaceAddressDetailsDto> => {
    return placesPort.getPlaceDetails(placeId);
  };

  return { execute };
};
